import { atomWithReset } from "jotai/utils";

export const toggleReferenceMeasurementModeIsDisabledAtom =
  atomWithReset<boolean>(false);
